import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { observer } from 'mobx-react'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import FinancialSourceAccordio from '../../../../components/customElements/RequestDataAccordions/FinancialSourceAccordio'
import RightDrawer from '../../../../components/customElements/RightDrawer/RightDrawer'

const MassChangeTypeSubsidy = ({ store }) => {
  const {
    isMassChangeTypeSubsidyOpen,
    flagResonInstallation,
    toggleMassChangeTypeSubsidy,
    selectedOrders,
    massChangeTypeSubsidy,
    someFullDotationOld,
  } = store

  return (
    <RightDrawer
      open={isMassChangeTypeSubsidyOpen}
      onClose={toggleMassChangeTypeSubsidy}
      titleComp={
        <Box className={'fx-col'}>
          <Typography variant={'subtitle1'} color={'common.white'}>
            <FormattedMessage id={'Заявок выбрано'} />: {selectedOrders.size}
          </Typography>
          <Typography variant={'body1'} color={'#8FBFF6'}>
            <FormattedMessage id={'Изменение типа оплаты'} />
          </Typography>
        </Box>
      }
    >
      <FinancialSourceAccordio
        flagResonInstallation={flagResonInstallation}
        ids={[...selectedOrders]}
        massChangeTypeSubsidy={massChangeTypeSubsidy}
        someFullDotationOld={someFullDotationOld}
        createRequest
        massChange
      />
    </RightDrawer>
  )
}

export default observer(MassChangeTypeSubsidy)
